export enum RegisterSteps {
  Identify = 1,
  CreateAccount = 2,
  Access = 3,
}